<template>

	<!-- Active Users Card -->
	<a-card :bordered="false" class="dashboard-bar-chart">
		<chart-bar :height="220" :data="barChartData"></chart-bar>
		<div class="card-title">
			<h6>斗篷流量统计</h6>
		</div>
		<div class="card-content">
			<p>流量过滤概览</p>
		</div>
		<a-row class="card-footer" type="flex" justify="center" align="top">
			<a-col :span="6">
				<h4>{{total}}</h4>
				<span>访问量</span>
			</a-col>
			<a-col :span="6">
				<h4>{{pass}}</h4>
				<span>放行量</span>
			</a-col>
			<a-col :span="6">
				<h4>{{block}}</h4>
				<span>拦截量</span>
			</a-col>
		</a-row>
	</a-card>
	<!-- Active Users Card -->

</template>

<script>

	// Bar chart for "Active Users" card.
	import ChartBar from '../Charts/ChartBar' ;
	import {getActiveAnalysis} from '@/api/index'

	export default ({
		components: {
			ChartBar,
		},
		data() {
			return {
				// Data for bar chart.
				barChartData: {
					labels: [],
					datasets: [],
				},
				block:0,
				pass:0,
				total:0
			}
		},
		mounted(){
			getActiveAnalysis().then(res=>{
				this.barChartData.labels = res.data.user
				this.barChartData.datasets = [{
						label: "放行数",
						backgroundColor: '#fff',
						borderWidth: 0,
						borderSkipped: false,
						borderRadius: 6,
						data: res.data.active,
						maxBarThickness: 20,
				}]
				this.pass = res.data.pass
				this.block = res.data.block
				this.total = res.data.total
			})
		}
	})

</script>